
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kampanjer",
      function () {
        return require("private-next-pages/kampanjer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kampanjer"])
      });
    }
  